import React from 'react';
import styled from 'styled-components';
import Text from '@ingka/text';
import Progress, { Page } from './Progress';
import { colors } from '../styles';
import useTranslation from '../hooks/useTranslation';

export interface AppHeaderProps {
  page?: Page;
  children?: React.ReactNode;
}

const StyledDivider = styled.div`
  margin-bottom: 2.5rem;
  border-top: 1px solid ${colors.neutral.grey200};
`;

const StyledHeader = styled(Text)`
  &&& {
    text-align: center;
    margin: 0.67em 0;
  }
`;

const getKey = (page?: Page): string | undefined => {
  if (page) {
    return `pages.${page}.pageTitle`;
  }
};

const AppHeader: React.FC<AppHeaderProps> = ({
  page,
  children,
}): JSX.Element => {
  const { t } = useTranslation();
  const ariaTranslationKey = getKey(page);
  return (
    <>
      <StyledHeader
        tagName="h1"
        textStyle="Heading.M"
        aria-label={ariaTranslationKey && t(ariaTranslationKey)}
      >
        {t('components.appHeader.title')}
      </StyledHeader>
      {page && <Progress page={page} />}
      {children}
      <StyledDivider />
    </>
  );
};

export default AppHeader;
